import joinUrl from '@ogury/url-join';
import 'url-polyfill';
import { replacerWithoutPattern } from './utils';

export function replaceGdprMacros(
  url: string,
  macros: Record<string, any> = {}
): string {
  let templatedUrl = url;
  templatedUrl = replacerWithoutPattern(
    templatedUrl,
    /((#|\$){|\[|%5B)(gdpr|is_gdpr)(}|\]|%5D)/gi,
    macros.gdpr
  );
  templatedUrl = replacerWithoutPattern(
    templatedUrl,
    /((#|\$){|\[|%5B)(tcfv2|gdpr_consent_string|gdpr_consent)(}|\]|%5D)/gi,
    macros.tcfv2
  );
  templatedUrl = replacerWithoutPattern(
    templatedUrl,
    /((#|\$){|\[|%5B)gdpr_consent_[0-9]+(}|\]|%5D)/gi,
    macros.tcfv2
  );

  const regexPersonalMacro = /((#|$){|\[|%5B)+(aaid|user_agent|user_advertising_id|ip)(]|})+/gi;
  templatedUrl = replacerWithoutPattern(
    templatedUrl,
    /((#|\$){|\[|%5B)gdpr_pd(}|\]|%5D)/gi,
    templatedUrl.match(regexPersonalMacro) ? '1' : '0'
  );
  return templatedUrl;
}

export function templateMacros(
  url: string = '',
  macros: Record<string, any> = {}
): string {
  let templatedUrl = url.slice();

  templatedUrl = replaceGdprMacros(templatedUrl, macros);
  Object.keys(macros).forEach(macro => {
    templatedUrl = replacerWithoutPattern(
      templatedUrl,
      new RegExp(`\\[${macro}\\]`, 'gi'),
      encodeURIComponent(macros[macro])
    );
  });

  return templatedUrl;
}

export function templateMacrosEncoded(
  url: string = '',
  macros: Record<string, any> = {}
): string {
  let templatedUrl = url.slice();

  Object.keys(macros).forEach(macro => {
    templatedUrl = replacerWithoutPattern(
      templatedUrl,
      new RegExp(`%5B${macro}%5D`, 'gi'),
      encodeURIComponent(macros[macro])
    );
  });

  return templatedUrl;
}

export function updateQueryStringParameters(
  url: string,
  params: Record<string, any>
): string {
  if (!url || !params) return '';

  let hash: string | undefined;
  [url, hash] = url.split('#');
  hash = hash ? '#' + hash : '';

  try {
    const parsedUrl = new URL(url);
    const queryParameters = new URLSearchParams(parsedUrl.search);

    Object.keys(params).forEach(key => {
      if (typeof params[key] !== 'boolean' && !params[key]) {
        return;
      }

      queryParameters.set(key, params[key]);
    });

    const queryParametersString = queryParameters
      .toString()
      .split('&')
      .sort((a, b) => {
        const regex = new RegExp(/force_redirect/);
        if (regex.test(a)) {
          return +1;
        } else if (regex.test(b)) {
          return -1;
        }
        return 0;
      })
      .join('&');

    return joinUrl(
      parsedUrl.origin,
      parsedUrl.pathname,
      '?' + queryParametersString + hash
    );
  } catch {
    if (window.isOgyPreview && params.force_redirect) {
      return params.force_redirect;
    }
    return url + hash;
  }
}

export function isValidUrl(url: string): boolean {
  const urlRegex = /^[a-zA-Z0-9]+:\/\/.*/;
  return Boolean(url) && urlRegex.test(url);
}

export function isSpecialUrlScheme(url: string): boolean {
  const urlRegex = /^(mailto|tel):[^/]{2}.+/;
  return Boolean(url) && urlRegex.test(url);
}

export function checkIntentUrl(
  originalIntent: string,
  isResolved: boolean,
  hasLimitedPackageVisibility: boolean
): string {
  // Fallback if intent is not resolved and if we have not a limited package visibility (Android 11)
  if (!isResolved && !hasLimitedPackageVisibility) {
    if (originalIntent.indexOf('intent:') !== 0) {
      return '';
    }

    const [, packageName] = originalIntent.match(/package=(.*);/) || [];
    if (!packageName) {
      return '';
    }
    return `market://details?id=${packageName}`;
  }

  return originalIntent;
}

export function generateUrlWithRegion(
  endPoint?: string,
  region?: string
): string {
  if (!endPoint) {
    return '';
  }

  if (!region || endPoint.indexOf('localhost') !== -1) {
    return endPoint;
  }

  const segmentUrl = endPoint.split('.', 1);
  return endPoint.replace(segmentUrl[0], `${segmentUrl[0]}-${region}`);
}
